<template>
  <div
    :class="['sticker', `sticker__${type}`, { sticker__arrow: isArrow }]"
    @click.stop.prevent="onClick"
  >
    <render />
  </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  type: {
    type: String,
    default: 'percent',
    validator: (value: string) =>
      [
        'minimal',
        'percent',
        'rub',
        'percent-monitoring',
        'percent-sale',
      ].includes(value),
  },
  text: {
    type: [String, Number],
    default: '',
  },
  isClick: {
    type: Boolean,
    default: false,
  },
});
const emit = defineEmits(['click-sticker']);

const isArrow = computed(() => {
  const isArrowTypes = ['minimal', 'percent-monitoring'];
  return isArrowTypes.includes(props.type) && props.isClick;
});
const onClick = () => {
  if (props.isClick) {
    emit('click-sticker');
  }
};
const render = () => {
  const lastMargin =
    props.type === 'percent-monitoring' ? 'sticker-item__last' : '';
  const percentBlock = `<span class="sticker-item sticker-item__big">-</span><span class="sticker-item sticker-item__big">${props.text}</span><span class="${lastMargin} sticker-item__big">%</span>`;
  const returnHTML = new Map([
    ['minimal', `<span class="sticker-text-wrap">Дешевле не найти</span>`],
    [
      'percent-monitoring',
      `<span class="sticker-text-wrap">${percentBlock}от рыночной цены</span>`,
    ],
    [
      'percent-sale',
      `<span class="sticker-text-wrap">скидки до <span class="sticker-item__big">${props.text}</span> %</span>`,
    ],
    ['percent', `<span class="sticker-text-wrap">${percentBlock}</span>`],
    [
      'rub',
      `<span class="sticker-text-wrap"><span class="sticker-item">-</span><span class="sticker-item  sticker-item__big">${props.text}</span><span class="sticker-item">₽</span></span>`,
    ],
  ]);
  const getHTML = (type: string) => {
    return returnHTML.get(type);
  };

  return h('span', { innerHTML: getHTML(props.type) });
};
</script>
<style scoped lang="scss">
.sticker {
  position: relative;
  padding: 0 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: max-content;
  height: 18px;
  border-radius: 4px;
  text-transform: uppercase;
  font-style: normal;
  font-weight: 600;
  font-size: 10px;
  line-height: 10px;
  color: $white;
  @include lg-block {
    height: 20px;
    font-size: 12px;
    line-height: 12px;
  }

  &__arrow {
    padding-right: 20px;
    cursor: pointer;

    &:after {
      content: '';
      position: absolute;
      top: calc(50% - 6px);
      right: 4px;
      mask: url('/static/images/icon/arrow-right.svg') center / contain
        no-repeat;
      background-color: $white;
      width: 12px;
      height: 12px;
      @include lg-block {
        top: calc(50% - 8px);
        width: 16px;
        height: 16px;
      }
    }
  }

  &__minimal {
    background: #f32382;
  }

  &__percent-monitoring {
    background: #f32382;
  }

  &__percent-sale {
    background: $purple;
  }

  &__percent,
  &__rub {
    background: #ef1f29;
  }

  :deep(.sticker-item) {
    margin-right: 1px;
  }

  :deep(.sticker-item__last) {
    margin-right: 3px;
  }

  :deep(.sticker-item__big) {
    font-size: 12px;
    @include lg-block {
      font-size: 14px;
    }
  }

  // визуальное выравнивание шрифта
  //:deep(.sticker-text-wrap) {
  //padding-top: 2px;
  //}
}
</style>
